import React from 'react';
import { AdministrationMenu, InternalEntities, EntitiesMenu } from 'app/entities/menu';

export const SideBar = ({ authorities, permissions }) => {
  return (
    <>
      <EntitiesMenu authorities={authorities} permissions={permissions} />
      <AdministrationMenu authorities={authorities} permissions={permissions} />
      <InternalEntities authorities={authorities} permissions={permissions} />
    </>
  );
};
